module["exports"] = [
  "com",
  "com",
  "com",
  "net",
  "org",
  "it",
  "it",
  "it"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/internet/domain_suffix.js
// module id = 1303
// module chunks = 0